import { render } from "./testimonials.vue?vue&type=template&id=de2a1ee6"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__